<script setup lang="ts">
import fetchFUN from '@/error_watch/requset'
import { useNewpageData } from "@/stroe/pinia";

const NewpageData = useNewpageData()
NewpageData.GetLocSetError()
//上传 上次未上传 错误数组
const haveold = async (data: any) => {
  try {
    let res = await fetchFUN('error', data)
    if (res.status == 1) {
      console.log('未上传错误数组上传成功');
      localStorage.removeItem('olderror')
    } else {
      console.log('未上传错误数组上传失败');
    }
  } catch (error) {
    throw error
  }
}
if (localStorage.getItem('olderror')) {
  let data: any = JSON.parse(localStorage.getItem('olderror')!)
  console.log('本地有未上传的错误数组', data);
  haveold(data)
}
</script>
<template>
  <RouterView />
</template>

<style scoped></style>
